// import { parsePhoneNumber } from 'libphonenumber-js';
import emptyValidator from './emptyValidator';
import defaultValidator from './defaultValidator';
import textValidator from './textValidator';

const getValidator = (errorType) => {
  switch (errorType) {
    case 'IS_BLANK_ERROR':
      return emptyValidator;
    case 'TYPE_INVALID':
      return textValidator;
    default:
      return defaultValidator;
  }
};

const regExList = {
  userid: /^[0-9]{11}$/,
  postcode:
    /^(([gG][iI][rR] {0,}0[aA]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkstuwA-HJKSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y]))) {0,}[0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2}))$/,
  email: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/,
  phone: /^(\(?\+?[0-9]*\)?)?[0-9_\- \\(\\)]*$/,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/,
  name: /^([a-zA-Z\s-'`]+)$/,
  address: /^([a-zA-Z0-9\s.\-,`']*)$/,
  mobile:
    /^([(]*0[\s-()]*7|[+]?[(]*44[\s-()]*7|[+]?44\s*[(]0[)]\s*7)([\s-()]*[0-9]){9}$/,
};

const validate = (field) => {
  const { value, options: { constraints }, type: fieldType, validationType } = field;
  /*eslint-disable no-unused-vars*/
  for (const errorType in constraints) {
    if (Object.prototype.hasOwnProperty.call(constraints, errorType)) {
      const message = (fieldType === 'Date') ? 'Please enter valid date' : constraints[errorType];
      const error = getValidator(errorType)(value, message);
      if (error) return error;
    }
  }
  // const regionCode = 'GB';
  let textError = null;

  if (!value) {
    return null;
  }

  switch (validationType) {
    case 'Email':
      if (!value.match(regExList.email)) {
        textError = getValidator('TYPE_INVALID')(value, 'Please enter valid Email');
      }
      break;
    case 'Tel':
      if (value.length < 10 || !value.match(regExList.phone)) {
        textError = getValidator('TYPE_INVALID')(value, 'Please enter valid Phone Number');
        break;
      }
      // if (!parsePhoneNumber(value, regionCode).isValid()) {
      //   textError = getValidator('TYPE_INVALID')(value, 'Please enter valid Phone Number');
      // }
      break;
    default:
      textError = null;
      break;
  }
  return textError;
};

export default validate;
